import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Terms & Conditions
            </h1>
            <div className="w-20 h-1 bg-blue-600"></div>
          </div>

          <Card>
            <CardContent className="p-8">
              <div className="prose max-w-none space-y-4 text-gray-700">
                <p className="text-lg font-medium text-gray-900">
                  Chirosport SA Terms & Conditions
                </p>

                <p>
                  This Terms & Conditions page will contain detailed information about the terms of
                  use, membership requirements, and guidelines for using the Chirosport SA website
                  and services.
                </p>

                <p className="italic text-gray-600">
                  Terms & Conditions content to be updated by Chirosport SA administration.
                </p>

                <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                  <p className="text-sm text-gray-700">
                    For questions about our terms, please contact us at{' '}
                    <a href="mailto:admin@chirosport.co.za" className="text-blue-600 hover:text-blue-700">
                      admin@chirosport.co.za
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Terms;